import { NoticeType } from 'antd/lib/message/interface';
import { ArgsProps } from 'antd/lib/notification/interface';

export type MessageEventArgs = ArgsProps & {
  extensions?: Record<string, string | number | boolean>;
};

export type MessageDetail = {
  type: NoticeType;
  args: MessageEventArgs;
};

function getEvent(type: NoticeType, args: MessageEventArgs) {
  return new CustomEvent('messageEvent', {
    detail: {
      type,
      args,
    },
  });
}

function addEvent(type: NoticeType, args: MessageEventArgs) {
  if (__CLIENT__) {
    document.dispatchEvent(getEvent(type, args));
  }
}

type MessageArgs = MessageEventArgs | string;

export const message = {
  info: (args: MessageArgs) => {
    addEvent('info', args as MessageEventArgs);
  },
  success: (args: MessageArgs) => {
    addEvent('success', args as MessageEventArgs);
  },
  error: (args: MessageArgs) => {
    addEvent('error', args as MessageEventArgs);
  },
  warning: (args: MessageArgs) => {
    addEvent('warning', args as MessageEventArgs);
  },
};
